import {Box, SimpleGrid} from '@chakra-ui/react';
import {FC} from 'react';
import NextImageUI from 'ui/NextImage';

interface PaymentMethod {
  src: string;
  alt: string;
}

interface IProps {
  spacing?: string | string[];
  boxSize?: string | string[];
  borderColor?: string;
}

const paymentMethods: PaymentMethod[] = [
  {src: '/bpay.jpg', alt: 'Bpay'},
  {src: '/mia.jpg', alt: 'Mia'},
  {src: '/visa_logo.jpg', alt: 'Visa'},
  {src: '/mc.svg', alt: 'Mastercard'},
];

export const PaymentMethods: FC<IProps> = ({
  spacing = ['2px', '5px'],
  boxSize = ['48px', '64px'],
  borderColor = '#E2E8F0',
}) => {
  const boxHeight = Array.isArray(boxSize)
    ? boxSize.map((size) => `calc(${size} * 0.625)`)
    : `calc(${boxSize} * 0.625)`;

  return (
    <SimpleGrid columns={[2, 4]} spacing={spacing} justifyItems="center">
      {paymentMethods.map((method, index) => (
        <Box
          key={index}
          width={boxSize}
          height={boxHeight}
          border={`1px solid ${borderColor}`}
          display="flex"
          alignItems="center"
          justifyContent="center"
          overflow="hidden"
          borderRadius="4px"
        >
          <NextImageUI
            width={Array.isArray(boxSize) ? parseInt(boxSize[1] || boxSize[0]) : parseInt(boxSize)}
            height={Array.isArray(boxSize) ? parseInt(boxSize[1] || boxSize[0]) * 0.625 : parseInt(boxSize) * 0.625}
            src={method.src}
            alt={method.alt}
          />
        </Box>
      ))}
    </SimpleGrid>
  );
};

export default PaymentMethods;
